import React from 'react'
import styles from './styles.module.scss'

export function PrivacyPolicyRender() {
  return (
    <div className={styles.termsTemplate}>
      <p className={styles.lastUpdate}>
        Última atualização: 12 de setembro de 2025
      </p>

      <div className={styles.space}>
        <h2>QUEM SOMOS E A QUE ESTA POLÍTICA SE APLICA</h2>
        <p>
          Nós, RESALE TECNOLOGIA E SERVIÇOS S.A. (“Resale”), CNPJ nº
          21.129.873/0001-79, com sede na Av. Independência, 950, salas 22/24,
          Piracicaba/SP, editamos esta Política de Privacidade (“Política”) para
          explicar de forma clara como tratamos seus dados pessoais quando você:
          (i) visita o site www.resale.com.br ; (ii) utiliza a Plataforma
          Pagimovel®; e/ou (iii) acessa portais parceiros operados pela Resale
          em modelo white label.
        </p>
        <p>
          Aqui informamos quais dados coletamos, como usamos, com quem
          compartilhamos, por quanto tempo armazenamos e quais são os seus
          direitos, em conformidade com a Lei Geral de Proteção de Dados (LGPD –
          Lei 13.709/2018).
        </p>
      </div>

      <div>
        <div className={styles.space}>
          <h2 className={styles.spaceTop}>1) INFORMAÇÕES COLETADAS</h2>

          <ol type="a">
            <li>
              <p>Dados fornecidos por você</p>
              <ol type="i">
                <li>
                  Incluem dados cadastrais, documentos para qualificação,
                  propostas, comunicações com suporte, participação em pesquisas
                  ou formulários.
                </li>
              </ol>
            </li>

            <li>
              <p>Dados coletados automaticamente</p>
              <ol type="i">
                <li>
                  Coletamos informações de navegação (ex.: IP, data e hora,
                  dispositivo/navegador, páginas acessadas, cliques), com uso de
                  cookies e tecnologias semelhantes (pixels, tags). Detalhes na
                  nossa Política de Cookies
                </li>
              </ol>
            </li>

            <li>
              <p>Configurações de cookies</p>
              <ol type="i">
                <li>
                  Você pode gerenciar cookies no navegador. O bloqueio pode
                  limitar funcionalidades da Plataforma.
                </li>
              </ol>
            </li>

            <li>
              <p>Bases legais</p>
              <ol type="i">
                <li>
                  Tratamos dados com fundamento nas hipóteses da LGPD: execução
                  de contrato, cumprimento de obrigação legal/regulatória,
                  legítimo interesse e, quando necessário, consentimento (ex.:
                  marketing e cookies).
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            2) UTILIZAÇÃO E TRATAMENTO DAS INFORMAÇÕES
          </h2>

          <ol type="a">
            <li>
              <p>Finalidades</p>
              <ol type="i">
                <li>
                  Utilizamos seus dados para:
                  <div>
                    <p>(1) cadastrar e autenticar usuários;</p>
                    <p>
                      (2) viabilizar a participação nas modalidades de venda;
                    </p>
                    <p>(3) comunicar status, atualizações e suporte;</p>
                    <p>(4) cumprir obrigações legais/regulatórias;</p>
                    <p>(5) prevenir fraudes e garantir segurança;</p>
                    <p>
                      (6) analisar e melhorar produtos, serviços e
                      funcionalidades;
                    </p>
                    <p>
                      (7) cenviar comunicações e marketing, quando permitido,
                      com opção de descadastramento.
                    </p>
                  </div>
                </li>
              </ol>
            </li>

            <li>
              <p>Marketing / opt-out</p>
              <ol type="i">
                <li>
                  Você pode cancelar o recebimento de e-mails promocionais a
                  qualquer momento, utilizando o link no próprio e-mail ou
                  contatando o nosso DPO.
                </li>
              </ol>
            </li>

            <li>
              <p>Links de terceiros</p>
              <ol type="i">
                <li>
                  A Resale não se responsabiliza por práticas de coleta/uso em
                  sites externos vinculados à Plataforma.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            3) COMPARTILHAMENTO DE INFORMAÇÕES
          </h2>

          <ol type="a">
            <li>
              <p>Podemos compartilhar dados pessoais:</p>
              <ol type="i">
                <li>
                  com vendedores (inclusive exclusivos em portais
                  parceiros/white label), Pagimovel® e canais de venda (CRECI e
                  leiloeiros), estritamente para execução das operações;
                </li>
                <li>
                  com prestadores de serviços (infraestrutura, hospedagem,
                  e-mail, analytics, antifraude), mediante contratos de
                  confidencialidade;
                </li>
                <li>
                  com autoridades públicas ou judiciais, quando exigido por lei;
                </li>
                <li>para proteger direitos da Resale em disputas;</li>
                <li>
                  em operações societárias (fusão, aquisição ou incorporação),
                  assegurada a continuidade da proteção dos dados.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>4) ARMAZENAMENTO E SEGURANÇA</h2>

          <ol type="a">
            <li>
              <p>Local</p>
              <ol type="i">
                <li>
                  Armazenamos dados em servidores próprios ou de terceiros, no
                  Brasil ou no exterior.
                </li>
              </ol>
            </li>

            <li>
              <p>Medidas de segurança</p>
              <ol type="i">
                <li>
                  Adotamos práticas como criptografia, controle de acesso,
                  políticas internas, registros de log e cláusulas de
                  confidencialidade com colaboradores e parceiros.
                </li>
              </ol>
            </li>

            <li>
              <p>Limites</p>
              <ol type="i">
                <li>
                  Nenhum ambiente digital é 100% seguro. Incentivamos o uso de
                  boas práticas de segurança pelo usuário.
                </li>
              </ol>
            </li>

            <li>
              <p>Transferência internacional</p>
              <ol type="i">
                <li>
                  Eventuais transferências seguirão as hipóteses da LGPD, art.
                  33, com garantias adequadas de proteção.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>5) RETENÇÃO E EXCLUSÃO</h2>

          <ol type="a">
            <li>
              <p>Prazos de retenção</p>
              <ol type="i">
                <li>
                  Mantemos dados pelo tempo necessário para cumprir as
                  finalidades desta Política e obrigações legais/regulatórias.
                </li>
              </ol>
            </li>

            <li>
              <p>Exclusão</p>
              <ol type="i">
                <li>
                  Você pode solicitar exclusão conforme a Política de Exclusão
                  de Dados . A exclusão pode ser adiada ou inviável quando
                  houver base legal para retenção (ex.: obrigação legal, defesa
                  em processos).
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>6) ACEITE</h2>

          <p>
            O aceite desta Política ocorre no ato do cadastro ou uso da
            Plataforma. Para cookies e marketing, quando exigido, solicitamos
            consentimento específico. Aplica-se também o Termo de Uso –
            Plataforma Resale e Portais Associados.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>7) ATUALIZAÇÕES</h2>

          <p>
            Esta Política poderá ser atualizada para refletir mudanças legais,
            regulatórias ou operacionais. A nova versão será publicada com data
            de atualização e, quando relevante, poderá ser exibido aviso
            destacado na Plataforma.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>8) DIREITOS DO TITULAR E CONTATO</h2>

          <ol type="a">
            <li>
              <p>Direitos (LGPD)</p>
              <ol type="i">
                <li>
                  Você pode solicitar: confirmação de tratamento; acesso aos
                  dados; correção; anonimização, bloqueio ou eliminação;
                  portabilidade; informações sobre compartilhamento; revogação
                  de consentimento; revisão de decisões automatizadas.
                </li>
              </ol>
            </li>
            <li>
              <p>Canal de contato (DPO)</p>
              <ol type="i">
                <li>
                  Encarregada (DPO):{' '}
                  <a href="mailto:dpo@resale.com.br" rel="noreferrer">
                    dpo@resale.com.br
                  </a>
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>9) LEGISLAÇÃO E FORO</h2>

          <p>
            Esta Política será regida pela legislação brasileira. Fica eleito o
            Foro da Comarca de São Paulo/SP, com renúncia a qualquer outro, por
            mais privilegiado que seja.
          </p>
        </div>
      </div>

      <p className={styles.version}>DOR033 - v3.0 - 20250912</p>
    </div>
  )
}
